var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#278DEC;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.8,332.2h-11.9v53.4h11.9c5.8,0,10.5-2,13.9-5.9c3.4-4,5.2-9,5.2-15.2v-11.2c0-6.1-1.7-11.2-5.2-15.1 C135.3,334.2,130.7,332.2,124.8,332.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M199.6,386.4c5.6,0,10-2,13.2-5.9s4.8-8.9,4.8-15.1v-13.2c0-6.1-1.6-11.1-4.9-15c-3.2-3.9-7.6-5.9-13.2-5.9 c-5.4,0-9.6,2-12.7,5.9c-3.1,3.9-4.6,8.9-4.6,15v13.2c0,6.1,1.6,11.2,4.7,15.1C190,384.5,194.2,386.4,199.6,386.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M458,118.2L346.5,8.4C345,6.9,342.9,6,340.7,6H135c-31.1,0-56.3,26.6-56.3,59.4v219.2H51.3v148.6h27.4v13.4 c0,32.7,25.3,59.4,56.3,59.4h269.4c31.1,0,56.3-26.6,56.3-59.4V124.7C460.7,122.3,459.8,119.9,458,118.2z M337.9,24.4l97,95.6 h-52.8c-24.4,0-44.2-19.5-44.2-43.4V24.4z M443.7,446.6c0,22.9-17.6,41.5-39.3,41.5H135c-21.7,0-39.3-18.6-39.3-41.5v-13.4h187 c36.5,0,66-33.3,66-74.3s-29.6-74.3-66-74.3h-187V65.4c0-22.9,17.6-41.5,39.3-41.5h185.9v52.7c0,33.8,27.4,61.3,61.2,61.3h61.6 L443.7,446.6L443.7,446.6z M100.7,395.4v-72.9h24.1c9.2,0,16.8,2.9,22.6,8.7c5.8,5.8,8.7,13.2,8.7,22.3v11.1 c0,9.1-2.9,16.5-8.7,22.3c-5.8,5.7-13.3,8.6-22.6,8.6h-24.1V395.4z M170.1,365.5v-13.1c0-8.9,2.7-16.3,8.2-22.1 c5.5-5.9,12.6-8.8,21.3-8.8c8.9,0,16.2,2.9,21.8,8.8s8.4,13.3,8.4,22.1v13.1c0,8.9-2.8,16.3-8.4,22.2c-5.6,5.9-12.9,8.8-21.8,8.8 c-8.7,0-15.8-2.9-21.3-8.8C172.8,381.8,170.1,374.4,170.1,365.5z M260.1,380.8c2.9,3.9,6.9,5.9,12,5.9c5,0,8.8-1.3,11.3-3.9 c2.6-2.6,3.9-6.4,3.9-11.3H299l0.1,0.3c0.1,7.3-2.3,13.3-7.2,17.8c-4.9,4.5-11.5,6.8-19.9,6.8c-8.5,0-15.4-2.9-20.6-8.6 c-5.3-5.7-7.9-13-7.9-22V352c0-8.9,2.6-16.2,7.8-22s12-8.6,20.4-8.6c8.6,0,15.3,2.2,20.3,6.6c4.9,4.4,7.3,10.4,7.2,18l-0.1,0.3 h-11.8c0-4.9-1.3-8.6-4-11.2c-2.6-2.6-6.5-3.9-11.6-3.9c-4.9,0-8.9,2-11.7,5.9c-2.9,3.9-4.3,8.9-4.3,14.8v14 C255.7,371.9,257.2,376.9,260.1,380.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordIcon);
export default __webpack_public_path__ + "static/media/wordIcon.33f82e611a0f8f4fce2ba122cceec85c.svg";
export { ForwardRef as ReactComponent };